// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__7kCav","arrow":"Pagination_arrow__TMS1l"};